interface PreviewTokenData {
  accessToken: string;
  organizationId?: number;
  expiresAt?: string;
  roleName?: string;
  eventId?: number;
  canEdit?: boolean;
}

const STORAGE_KEY = 'manager_preview_token';
const COOKIE_NAME = 'rts_organizer_token';
const ROLE_COOKIE_NAME = 'rts_organizer_role';
const CAN_EDIT_COOKIE_NAME = 'rts_organizer_can_edit';

export function storeOrganizerTokens(tokens: PreviewTokenData): void {
  if (typeof window === 'undefined') return;

  localStorage.setItem(STORAGE_KEY, JSON.stringify(tokens));

  const maxAge = tokens.expiresAt
    ? Math.max(0, Math.floor((new Date(tokens.expiresAt).getTime() - Date.now()) / 1000))
    : 3600;

  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=${tokens.accessToken}; path=/; SameSite=Lax; Max-Age=${maxAge}${secure}`;
  const roleValue = tokens.roleName ? encodeURIComponent(tokens.roleName) : '';
  document.cookie = `${ROLE_COOKIE_NAME}=${roleValue}; path=/; SameSite=Lax; Max-Age=${maxAge}${secure}`;
  const canEditValue = tokens.canEdit ? 'true' : 'false';
  document.cookie = `${CAN_EDIT_COOKIE_NAME}=${canEditValue}; path=/; SameSite=Lax; Max-Age=${maxAge}${secure}`;
}

export function getStoredOrganizerTokens(): PreviewTokenData | null {
  if (typeof window === 'undefined') return null;

  const json = localStorage.getItem(STORAGE_KEY);
  if (!json) return null;

  try {
    return JSON.parse(json) as PreviewTokenData;
  } catch {
    return null;
  }
}

export function clearOrganizerTokens(): void {
  if (typeof window === 'undefined') return;

  localStorage.removeItem(STORAGE_KEY);
  document.cookie = `${COOKIE_NAME}=; path=/; SameSite=Lax; Max-Age=0`;
  document.cookie = `${ROLE_COOKIE_NAME}=; path=/; SameSite=Lax; Max-Age=0`;
  document.cookie = `${CAN_EDIT_COOKIE_NAME}=; path=/; SameSite=Lax; Max-Age=0`;
}
